import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxNumberValidator(max: number): ValidatorFn {
  return (control: AbstractControl<number>): ValidationErrors | null => {
    if (max === undefined || max === null) return null;
    const value = control.value;
    if (value === null || value === undefined) return null;
    if (typeof value !== 'number') { return null; }
    return value > max ? { max: { max, actual: value }} : null;
  };
}

export function minNumberValidator(min: number): ValidatorFn {
  return (control: AbstractControl<number>): ValidationErrors | null => {
    if (min === undefined || min === null) { return null; }
    const value = control.value;
    if (value === null || value === undefined) return null;
    if (typeof value !== 'number') { return null; }
    return value < min ? { min: { min, actual: value }} : null;
  };
}
